// src/managerPortal/pages/SignIn.js
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../styles/SignIn.css";
import apiUrl from "../../config"; // Import our dynamic API URL

const SignIn = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(""); // Clear previous errors

        try {
            const response = await axios.post(
                `${apiUrl}/api/auth/login`,
                { username, password },
                { withCredentials: true } // Ensures cookies are stored
            );

            if (response.data.message === "Login successful") {
                navigate("/manager/dashboard"); // Redirect to dashboard after login
            }
        } catch (err) {
            setError("Invalid username or password. Please try again.");
        }
    };

    return (
        <div className="signin-container">
            <div className="signin-card">
                <h2 className="signin-title">Manager Sign In</h2>
                {error && <p className="error-message">{error}</p>}
                <form onSubmit={handleSubmit} className="signin-form">
                    <div className="input-group">
                        <label htmlFor="username">Username</label>
                        <input
                            type="text"
                            id="username"
                            placeholder="Enter your username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className="input-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="signin-button">Sign In</button>
                </form>
            </div>
        </div>
    );
};

export default SignIn;
